var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.556 6.08705C17.0605 6.08705 18.274 4.86439 18.274 3.35993C18.274 1.85547 17.0605 0.632812 15.556 0.632812C14.0516 0.632812 12.8289 1.85547 12.8289 3.35993C12.8289 4.86439 14.0516 6.08705 15.556 6.08705ZM8.28369 6.08705C9.78815 6.08705 11.0017 4.86439 11.0017 3.35993C11.0017 1.85547 9.78815 0.632812 8.28369 0.632812C6.77923 0.632812 5.55657 1.85547 5.55657 3.35993C5.55657 4.86439 6.77923 6.08705 8.28369 6.08705ZM8.28369 7.90513C6.16108 7.90513 1.92041 8.96871 1.92041 11.0868V13.3594H14.647V11.0868C14.647 8.96871 10.4063 7.90513 8.28369 7.90513ZM15.556 7.90513C15.2924 7.90513 14.997 7.92331 14.6788 7.95513C15.7333 8.71418 16.4651 9.73685 16.4651 11.0868V13.3594H21.9193V11.0868C21.9193 8.96871 17.6786 7.90513 15.556 7.90513Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9989,
    height: 12.7266,
    fill: "white",
    transform: "translate(1.92041 0.632812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.cdce45bb5bca1bef41bea32b70775f69.svg";
export { ForwardRef as ReactComponent };